<script>
  export default {
    name: 'MapSuggestions',
    props: {
      selectedBank: {
        type: Object,
        required: true
      },
      showOrderMeetingForm: {
        type: Function,
        required: true
      },
      navigateBack: {
        type: Function,
        required: true
      },
      labels: {
        type: Object,
        required: true
      },
      trackActionCallback: {
        type: Function,
        required: true
      }
    }, 
    setup() {

        const handleWebsiteUrl = (url) => {
            if (url && url.startsWith('http')) {
                return url;
            }
            return `https://${url}`;
        }

        return {
            handleWebsiteUrl
        }
    }
}
</script>

<template>
    <div class="nyk-pi-map__map-section__selected-bank">
        <button class="nyk-button nyk-button--link nyk-button--back" v-on:click="navigateBack">
            <div class="nyk-button__icon">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 12"><path fill="#07094A" d="M14 6.607V5.376H2.63l3.898-4.243L5.858.5 0 6.009 5.858 11.5l.67-.633-3.898-4.26H14Z"/></svg>
            </div>
            {{ labels.backButton }}
        </button>

        <div class="nyk-pi-map__map-section__selected-bank__header">
            <h3 class="nyk-pi-map__map-section__selected-bank__header__title">{{ selectedBank.bankName }}</h3>
            <div class="nyk-pi-map__map-section__selected-bank__content">
              <div>
                <p class="nyk-pi-map__map-section__selected-bank__content__item">{{ selectedBank.address }}</p>
                <p class="nyk-pi-map__map-section__selected-bank__content__item">{{ selectedBank.zipcode }} {{ selectedBank.city }}</p>
                <p class="nyk-pi-map__map-section__selected-bank__content__item">Telefon: <a :href="`tel:${selectedBank.telephone}`" @click="() => trackActionCallback('ring til pi - click', selectedBank.bankName, selectedBank.external)">{{ selectedBank.telephone }}</a></p>
                <p class="nyk-pi-map__map-section__selected-bank__content__item">Email: <a :href="`mailto:${selectedBank.email}`" @click="() => trackActionCallback('skriv til pi - click', selectedBank.bankName, selectedBank.external)">{{ selectedBank.email }}</a></p>
              </div>
              <div class="nyk-pi-map__map-section__selected-bank__logo">
                  <img :src="selectedBank.logo" :alt="`${selectedBank.bankName} Logo`" />
              </div>
            </div>
            <div class="nyk-pi-map__map-section__selected-bank__actions">
                <a :href="handleWebsiteUrl(selectedBank.website)" class="nyk-button nyk-button--filled-primary" @click="() => trackActionCallback('gå til website - click', selectedBank.bankName, selectedBank.external)">
                  {{ labels.navigateToWebsite }}
                </a>

            </div>
        </div>

    </div>
</template>